import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const PromotedSponsorshipModuleAsyncComponent = AsyncComponent(async () => import('./promoted-sponsorship-module' /* webpackChunkName: "promoted-sponsorship-module" */ ));

export const PromotedSponsorshipModuleAsync = (props) => {
  return <React.Suspense fallback={null}>
    <PromotedSponsorshipModuleAsyncComponent {...props}/>
  </React.Suspense>
};
